'use strict';

angular.module('bringgApp').factory('AddTasksCSVService', function ($rootScope, SocketPubSub) {
	SocketPubSub.on('task import done', function (event) {
		$rootScope.$broadcast('taskImportDone', event);
	});

	return {};
});
